import { defineCopy } from '@floorfile/i18n'
import { incidentsCopy } from './copy'

export const incidentsOfflineCopy = defineCopy('incidents', { offlineAction: incidentsCopy.en.offlineAction })
